import {Grid} from '@logistics-frontend/blocks'
import React from 'react'

import {DeliveryTimeSelect} from 'src/shared/components/desktop'
import {DueSettings} from 'src/shared/types'

import {DeliveryDateSelect} from '../../DeliveryDateSelect/DeliveryDateSelect'
import {useOrderTime} from './hooks'

type Props = {
  dueSettings: DueSettings
}

export function OrderTime({dueSettings}: Props): React.ReactElement {
  const {dates, intervals} = useOrderTime(dueSettings)

  return (
    <Grid size="s" container>
      <Grid item xs>
        <DeliveryDateSelect dates={dates} name="offerFlow.deliveryDate" noFormat />
      </Grid>
      <Grid item xs>
        <DeliveryTimeSelect intervals={intervals} name="offerFlow.deliveryTime" />
      </Grid>
    </Grid>
  )
}
